import React from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Typography,
    Tooltip,
    useTheme
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomCard from '../CustomCard/CustomCard';
import { AccordionCardProps } from './AccordionCard.types';

const AccordionCard = ({
    title,
    icon,
    children,
    defaultExpanded = true,
    tooltip,
    actions,
    variant = 'accordion'
}: AccordionCardProps) => {
    const theme = useTheme();

    const titleContent = (
        <Typography
            variant="h6"
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexGrow: 1,
                color: theme.palette.text.primary
            }}
        >
            {icon && (
                <Box sx={{ mr: 1, display: 'flex', alignItems: 'center', color: theme.palette.primary.main }}>
                    {icon}
                </Box>
            )}
            {tooltip ? (
                <Tooltip title={tooltip}>
                    <span>{title}</span>
                </Tooltip>
            ) : (
                title
            )}
        </Typography>
    );

    return (
        <CustomCard sx={{ mb: 4 }}>
            {variant === 'accordion' ? (
                <Accordion
                    defaultExpanded={defaultExpanded}
                    elevation={0}
                    sx={{
                        boxShadow: 'none',
                        backgroundColor: 'transparent'
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.text.secondary }} />}
                        sx={{ padding: 0, minHeight: 'unset' }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            {titleContent}
                            {actions && <Box>{actions}</Box>}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ px: 0 }}>
                        {children}
                    </AccordionDetails>
                </Accordion>
            ) : (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        {titleContent}
                        {actions && <Box>{actions}</Box>}
                    </Box>
                    {children}
                </>
            )}
        </CustomCard>
    );
};

export default AccordionCard;
